import React from "react";

import contactBg from "../../../assets/images/contact/common-bg.svg";

const ContactMe = () => {
  return (
    <section
      id="contactSection"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0, 0.9) 0%, rgba(0,0,0, 0.9) 100%), url(${contactBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        width: "100%",
        height: "70vh",
      }}
      className=" bg-main text-white relative"
    >
      <div id="stars"></div>
      <div id="stars2"></div> <div id="stars3"></div>
      <div id="sectionTitle" className="sectionTitle pt-20 pb-5 text-center">
        <h2 className="text-5xl font-bold">Contact Me</h2>
      </div>
      <div className="grid grid-cols-1 px-8 py-16 mx-auto lg:w-1/2">
        <form className="space-y-6 ng-untouched ng-pristine ng-valid">
          <div className="flex gap-3">
            <input
              id="name"
              type="text"
              placeholder="Full Name"
              className="w-full p-3 outline-none focus:border-b-secondary bg-transparent border-b-2 border-b-border"
            />
            <input
              id="subject"
              type="text"
              placeholder="Subject"
              className="w-full p-3 outline-none focus:border-b-secondary bg-transparent border-b-2 border-b-border"
            />
          </div>
          <div>
            <input
              id="email"
              type="email"
              placeholder="Email"
              className="w-full p-3 outline-none focus:border-b-secondary bg-transparent border-b-2 border-b-border"
              data-temp-mail-org="1"
            />
          </div>
          <div>
            <textarea
              id="message"
              rows="3"
              placeholder="Message"
              className="w-full p-3 outline-none focus:border-b-secondary bg-transparent border-b-2 border-b-border"
            ></textarea>
          </div>
          <button
            type="submit"
            className="p-3 text-sm font-bold tracking-widest uppercase rounded bg-secondary text-white"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactMe;
